function AuthorBackgroundLinesLeftSVG() {
  return (
    <svg
      width="272"
      height="295"
      viewBox="0 0 272 295"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <line
          x1="157.288"
          y1="0.773268"
          x2="-5.36577"
          y2="134.15"
          stroke="#FAB818"
          strokeWidth="2"
        />
        <line
          x1="271.769"
          y1="149.754"
          x2="8.40771"
          y2="87.18"
          stroke="#F47521"
          strokeWidth="2"
        />
        <line
          x1="228.915"
          y1="47.8901"
          x2="9.33222"
          y2="259.34"
          stroke="#EF4323"
          strokeWidth="2"
        />
        <line
          x1="123.464"
          y1="0.256333"
          x2="45.3897"
          y2="294.66"
          stroke="#2ABDBB"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export { AuthorBackgroundLinesLeftSVG };
